import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-59f52a0e"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", {
    class: "c-card-txt",
    style: _normalizeStyle({
      height: $props.height
    })
  }, [$props.info.img ? (_openBlock(), _createElementBlock("img", {
    key: 0,
    src: $props.info.img,
    style: _normalizeStyle($props.imgStyle),
    class: "img"
  }, null, 12, _hoisted_1)) : _createCommentVNode("", true), $props.info.icon ? _renderSlot(_ctx.$slots, "icon", {
    key: 1
  }, () => [_createElementVNode("div", {
    class: _normalizeClass(["icon iconfont", [$props.info.icon]])
  }, null, 2)], true) : _createCommentVNode("", true), $props.info.title ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "title",
    style: _normalizeStyle($props.titleStyle)
  }, _toDisplayString($props.info.title), 5)) : _createCommentVNode("", true), $props.info.desc ? (_openBlock(), _createElementBlock("div", {
    key: 3,
    class: "desc",
    style: _normalizeStyle($props.descStyle)
  }, [Array.isArray($props.info.desc) ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList($props.info.desc, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "desc-list-item"
    }, _toDisplayString(item), 1);
  }), 128)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createTextVNode(_toDisplayString($props.info.desc), 1)], 64))], 4)) : _createCommentVNode("", true), $props.info.btn ? (_openBlock(), _createBlock(_component_el_button, {
    key: 4,
    onClick: $options.handleGo
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.info.btnname || '查看详情'), 1)]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)], 4);
}